import styled from 'styled-components'
// import {
//   default as VARIABLES
// } from '../../themes/styles/variables'

// Wrapper
// ============================================================
export const UserDetailFormBuyerStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .section {
    &.form-group {
      label {
        flex: 0 0 195px;
      }
      @media (max-width: 1025px) {
        label.label_user_cat {
          flex: unset;
        }
      }
    }
  }

  .main-content {
    min-height: calc(100vh - 267px);
    position: relative;
  }

  /* Modifiers
  ------------------------------- */

  .loading {
    position: absolute;
    justify-content: center;
    align-items: center;
    width: 95%;
    height: 80%;
    background-color: white;

    &.none {
      display: none;
    }

    &.show {
      display: block;
    }
  }

  .checkbox-group {
    padding-left: 0;
  }

  .switcher {
    padding-left: 28px;
    .switch-wrapper {
      margin-right: 10px;
    }
  }

  /* Media queries
  ------------------------------- */
`

export const UserDetailFormAdminStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .section {
    &.form-group {
      label {
        flex: 0 0 85px;
      }
    }
  }

  .main-content {
    min-height: calc(100vh - 267px);
    position: relative;
  }

  /* Modifiers
  ------------------------------- */

  .loading {
    position: absolute;
    justify-content: center;
    align-items: center;
    width: 95%;
    height: 80%;
    background-color: white;

    &.none {
      display: none;
    }

    &.show {
      display: block;
    }
  }

  /* Media queries
  ------------------------------- */
`

export const UserDetailFormSupplierStyle = styled.div`
  /* Parent styles
  ------------------------------- */
  width: 100%;

  /* Child element styles
  ------------------------------- */
  .section {
    &.form-group {
      label {
        flex: 0 0 85px;
      }
    }
  }

  .main-content {
    min-height: calc(100vh - 267px);
    position: relative;
  }

  /* Modifiers
  ------------------------------- */

  .loading {
    position: absolute;
    justify-content: center;
    align-items: center;
    width: 95%;
    height: 80%;
    background-color: white;

    &.none {
      display: none;
    }

    &.show {
      display: block;
    }
  }

  /* Media queries
  ------------------------------- */
`
